export default {
  header: '{assetDisplayName} Schnellnavigation',
};
